const unusedFields = [
  {
    name: 'sceneNumber',
    label: 'Scene Number',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'sceneName',
    label: 'Scene Name',
    type: 'dropdown',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 1,
    w: 6,
    h: 1
  },
  {
    name: 'slateNumber',
    label: 'Slate Number',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'takeNumber',
    label: 'Take Number',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'name',
    label: 'Name',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'logNote',
    label: 'Log Note',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'comment',
    label: 'Comment',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'description',
    label: 'Description',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'tapeName',
    label: 'Tape Name',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'soundRoll',
    label: 'Sound Roll',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'cameraRoll',
    label: 'Camera Roll',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'dailyRoll',
    label: 'Daily Roll',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'labRoll',
    label: 'Lab Roll',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'action',
    label: 'Action',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'sceneSetting',
    label: 'Scene Setting',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'label',
    label: 'Label',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'timeOfDay',
    label: 'Time of Day',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'shot',
    label: 'Shot',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'nickname',
    label: 'Nickname',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'date',
    label: 'Date',
    type: 'date',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 6,
    h: 1
  },
  {
    name: 'color',
    label: 'Color',
    type: 'color',
    width: 245,
    height: 135,
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 4,
    h: 3,
    maxW: 11,
    maxH: 5
  },
  {
    name: 'rating',
    label: 'Rating',
    type: 'rating',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 3,
    h: 1,
    isResizable: false
  },
  {
    name: 'good',
    label: 'Good',
    type: 'checkbox',
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 2,
    h: 1,
    isResizable: false
  },
  {
    name: 'stopwatch',
    label: 'Stopwatch',
    type: 'stopwatch',
    width: 210,
    height: 235,
    suggestions: ['school', 'albert\'s car', 'david\'s house'],
    x: 0,
    y: 0,
    w: 4,
    h: 4,
    isResizable: false
  }
]

export const newTemplate = name => ({
  id: '_' + Math.random().toString(36).substr(2, 9),
  unusedFields: unusedFields,
  lists: {
    'scene': {
      'type': 'scene',
      'fields': [],
      'showStatus': true
    },
    'slate': {
      'type': 'slate',
      'fields': [],
      'showStatus': false
    },
    'take': {
      'type': 'take',
      'fields': [],
      'showStatus': false
    }
  },
  name
})


// WEBPACK FOOTER //
// ./util/scriptLogTemplate.js